import { Box, RangeInput, Text } from "grommet";
import { useEffect, useState } from "react";

export const RangeInputWithSteps = ({ value, onChange, steps, labelKey, descriptionKey, ...props }) => {

    const [valueInternal, setValueInternal] = useState(0);

    let shiftLabelValue = 0.5;
    let shiftDescriptionValue = 0.5;

    const onChangeInternal = (event) => {
        setValueInternal(parseInt(event.target.value, 10));
		onChange(parseInt(event.target.value, 10));
    };

	useEffect(() => {
		setValueInternal(value);
	}, [value])

    return (
		<Box fill gap="small" align="center" {...props}>
			<Box
				direction="row"
				justify="between"
				// style={{ position: "relative" }}
                fill
			>
				{steps.map((step, index) => {
					const leftPos = (index / (steps.length - 1)) * 100;
					shiftLabelValue += 0.5;
					return (
						<Box
							key={step.value}
							align="center"
                            width={'100px'}
							// style={{
							// 	position: "absolute",
							// 	left: `calc(${leftPos}% - ${shiftLabelValue}rem)`
							// }}
						>
							<Text
								weight={
									valueInternal === step.value ? "bold" : "normal"
								}
								color={
									valueInternal === step.value ? "brand" : "dark-4"
								}
								size="small"
                                textAlign="center"
							>
								{labelKey && typeof labelKey === 'function' ? labelKey(step.label) : step.label}
							</Text>
						</Box>
					);
				})}
			</Box>

			<RangeInput
				min={0}
				max={steps.length - 1}
				step={1}
				value={valueInternal}
				onChange={onChangeInternal}
                style={{ width: '90%' }}
			/>

			<Box direction="row" justify="between" fill>
				{steps.map((step, index) => {
                    const leftPos = (index / (steps.length - 1)) * 100;
					shiftDescriptionValue += 0.5;
                    return (
                        <Box key={step.value} width="140px" align="center">
                            <Text
                                size="12px"
                                textAlign="center"
                                color={valueInternal === step.value ? "dark-2" : "dark-5"}
                            >
                                {descriptionKey && typeof descriptionKey === 'function' ? descriptionKey(step.description) : step.description}
                            </Text>
                        </Box>
				    )}
                )}
			</Box>
		</Box>
	);
}